/**
 * Workbench management for CDP SDK.
 */

import { CDPSession, getSession } from '../session';

export class WorkbenchManager {
  constructor(private readonly session: CDPSession = getSession()) {}

  async top10Files(params?: Record<string, any>): Promise<Record<string, any>> {
    return this.session.get('/api/cdp/workbench/sys_file/top10', { params });
  }

  async myOperation(params?: Record<string, any>): Promise<Record<string, any>> {
    return this.session.get('/api/cdp/workbench/myOperation', { params });
  }
}
